module.exports = "pegasus/assets/col_1.png";